import { assert } from '@varos/util-typescript';
import { ReportingShellLoaderBaseConfig } from '../../base';
import { ReportingRootLoader } from './reportingRootlInterface';
import { useMemo } from 'react';
import {
    NotificationObject,
    ReportingAccountAggregate,
    TaskListAggregate,
} from '../../view';

export function createReportingRootLoader(
    config: ReportingShellLoaderBaseConfig
): ReportingRootLoader {
    const {
        repository,
        kernel: {
            infra: { formatter },
        },
    } = config;

    return {
        useLoad(context, props) {
            const meQuery = repository.me.useLookup(context, {
                suspense: true,
                staleTime: Infinity,
            });

            const workspaceQuery = repository.research.workspace.useLookup(
                context,
                {
                    default: true,
                    autocreate: true,
                },
                {
                    suspense: true,
                    staleTime: Infinity,
                }
            );

            assert(meQuery.status === 'success', 'expected suspense');
            const accountQuery = repository.account.useLookup(
                context,
                {
                    id: meQuery.data.account.id,
                },
                {
                    suspense: true,
                    staleTime: Infinity,
                }
            );

            assert(accountQuery.status === 'success', 'expected suspense');
            assert(workspaceQuery.status === 'success', 'expected suspense');

            const taskQuery = repository.assistant.task.useFind(
                context,
                {},
                {
                    suspense: true,
                    staleTime: Infinity,
                    refetchInterval(data, query) {
                        return 15000;
                    },
                }
            );

            assert(taskQuery.status === 'success', 'expected suspense');

            const account = useMemo(
                (): ReportingAccountAggregate => ({
                    me: meQuery.data,
                    account: accountQuery.data,
                }),
                [meQuery.data, accountQuery.data]
            );

            // Generate notifications with simpler titles and detailed descriptions
            const notificationItems: NotificationObject[] = [
                // {
                //     id: report.id,
                //     title: 'Report Updated',
                //     description: `${author.name} updated "${report.title}" ${formatTime(report.editedAt)}`,
                //     createdAt: report.editedAt,
                // },
                // {
                //     id: executiveSummary.id,
                //     title: 'Chapter Updated',
                //     description: `${author.name} updated "${executiveSummary.caption}" ${formatTime(executiveSummary.editedAt)}`,
                //     createdAt: executiveSummary.editedAt,
                // },
                // {
                //     id: benchmarks.id,
                //     title: 'Chapter Updated',
                //     description: `${author.name} updated "${benchmarks.caption}" ${formatTime(benchmarks.editedAt)}`,
                //     createdAt: benchmarks.editedAt,
                // },
            ];
            // .sort((a, b) => b.createdAt.getTime() - a.createdAt.getTime()); // Sort by most recent first

            const task = useMemo(
                (): TaskListAggregate => ({
                    items: taskQuery.data.map((item) => ({
                        task: item,
                    })),
                }),
                [taskQuery.data]
            );

            return {
                account,
                notification: {
                    items: notificationItems,
                },
                workspace: workspaceQuery.data,
                task,
            };
        },
    };
}
